// extracted by mini-css-extract-plugin
export default {"tableDiv":"primeTable_tableDiv__hH5kH","noData":"primeTable_noData__okaX5","loader":"primeTable_loader__KXrp0"};